export { countries } from './countries';
export { IBANMandatoryCountries } from './IBANMandatoryCountries';
export const PAYMENTS_LIMIT = 150;
export const EMPTY_PAYMENT_ROW_COUNT = 1;
export const KAPITI_PRODUCT_CODE = '1000';
export const dateFormatFocus = 'DD/MM/YYYY';
export const dateFormat = 'DD MMM YYYY';
export const dateFormatYY = 'DD MMM YY';
export const longDateFormat = 'DD MMMM YYYY';
export const apiDateFormat = 'YYYY-MM-DD';
export const timeFormat = 'ha';
export const longTimeFormat = 'h.mma';
export const dateFormatToday = '[Today]';
export const defaultBatchName = 'Batch Payment';
export const defaultBacsPaymentName = 'Bacs Payment';
export const batchNameMaxLength = '18';
export const defaultCreditCardReference = 'int trf to cc';
export const invalidReferenceCharactersRegex = /[^0-9A-Za-z&./ ]/g;
export const invalidFasterPaymentsReferenceCharactersRegex = /[^0-9A-Za-z.,()/='+:?!%&*<>;{@#" -]/g;
export const invalidBACSReferenceCharactersRegex = /[^0-9A-Za-z.&/ -]/g;
export const referenceMaxLength = '18';
export const bacsReferenceMaxLength = '18';
export const bacsReferenceMinLength = 6;
export const bacsHmrcReferenceMaxLength = '4';
export const chapsReferenceMaxLength = '140';
export const bacsNameMaxLength = '18';
export const amountLimit = 999999.0;
export const exoticAmountLimit = 999999999999.99;
export const CHAPS_IFT_BACS_AmountLimit = 99999999.99;
export const invalidBatchNameCharactersRegex = /[^0-9A-Za-z&./ ]/g;
export const amountDecimalPoint = 2;
export const paymentTypeOptions = [
	{
		labelText: 'One-off',
		id: 'single',
	},
	{
		labelText: 'Repeating',
		id: 'repeating',
	},
];

export const editCapabilities = {
	single: {
		add: false,
	},
	batch: {
		add: true,
	},
	repeating: {
		add: false,
	},
};
export const BACS_CREDIT_CODE = 'BCR';
export const BACS_DEBIT_CODE = 'BDB';

export const TYPE_FASTER_PAYMENTS = 'FASTER_PAYMENTS';
export const TYPE_FASTER_PAYMENTS_TO = 'FASTER_PAYMENTS_TO';
export const TYPE_BACS_CREDIT = 'BACS_CREDIT';
export const TYPE_BACS_DEBIT = 'BACS_DEBIT';
export const TYPE_IFT = 'IFT';
export const TYPE_CHAPS = 'CHAPS';
export const TYPE_SO = 'SO';
export const OTHER = 'other';
export const TYPE_DOMESTIC_PAYEE = 'TYPE_DOMESTIC_PAYEE';
export const TYPE_IFT_PAYEE = 'TYPE_IFT_PAYEE';

export const capabilities = {
	CAPABILITY_TYPE_BACS: 'BACS',
	CAPABILITY_TYPE_FASTER_PAYMENTS: 'FPS',
	CAPABILITY_TYPE_IFT: TYPE_IFT,
	CAPABILITY_TYPE_CHAPS: TYPE_CHAPS,
};

export const ACCOUNT_CAPABILITIES = {
	[TYPE_FASTER_PAYMENTS]: '/account/payments/uk/default/out,/account/payments/transfer/out',
	[TYPE_FASTER_PAYMENTS_TO]: '/account/payments/transfer/in',
	[TYPE_SO]: '/account/mandates/so/write',
	[TYPE_IFT]: '/account/payments/ift/out',
	[TYPE_CHAPS]: '/account/payments/chaps/out',
	[TYPE_BACS_CREDIT]: '/account/payments/bacscredit/out',
	[TYPE_BACS_DEBIT]: '/account/payments/bacsdebit/out',
	[TYPE_DOMESTIC_PAYEE]: '/account/beneficiaries/account/readwrite',
};

export const paymentTypeTabs = [
	{
		id: TYPE_FASTER_PAYMENTS,
		title: 'Faster payments and transfers',
	},
	{
		id: TYPE_CHAPS,
		title: 'CHAPS payments',
	},
	{
		id: TYPE_IFT,
		title: 'International payments',
	},
	{
		id: TYPE_BACS_CREDIT,
		title: 'Send money by Bacs',
	},
	{
		id: 'BACS_DEBIT',
		title: 'Collect money by Bacs',
	},
	{
		id: OTHER,
		title: 'Other',
	},
];

export const payeeTypes = {
	INTERNATIONAL: 'international',
	CHAPS: 'chaps',
};

export const searchMinimumLength = 3;

export const DAILY_LIMIT_ERROR_CODE = '156';
export const TRANSACTION_LIMIT_ERROR_CODE = '155';
export const REPEATING_PAYMENT_LIMIT_ERROR_CODE = '160';
export const CUSTOMER_DEVICE_ENROLLED_ERROR_CODE = '404';
export const MISSED_DEADLINE_ERROR_CODE = '2002';
export const PENDING_STATUS_ERROR_CODE = '70105';
export const FASTER_PAYMENTS_PENDING_STATUS_ERROR_CODE = '105';
export const FASTER_PAYMENTS_BATCH_PENDING_STATUS_ERROR_CODE = '3105';
export const calendarTypes = {
	CALENDAR_TYPE_BACS: 'bacs',
	CALENDAR_TYPE_EXOTIC: 'exotic',
	CALENDAR_TYPE_CHAPS: 'chaps',
};

export const bacsDebitTransactionCodeOptions = [
	{
		label: 'Please select',
		value: '',
	},
	{
		label: '01 (First Payment)',
		value: '01',
	},
	{
		label: '17 (Standard)',
		value: '17',
	},
	{
		label: '18 (Representation)',
		value: '18',
	},
	{
		label: '19 (Last Payment)',
		value: '19',
	},
];

export const MaximumRepeatingTimes = 300;
export const addPayeeFormLengths = {
	name: 138,
	sortCode: 6,
	accountNumber: 8,
	reference: 18,
	displayName: 50,
	internationalPayeeName: 33,
	addressLine1: 33,
	addressLine2: 33,
	postalCode: 10,
	city: 19,
	iban: 34,
	internationalAccountNumber: 34,
	bickOrSwiftMaxLength: 11,
	bickOrSwiftMinLength: 8,
	bankName: 33,
	clearingCode: 18,
	paymentReason: 140,
	chapsReference: 140,
	chapsName: 138,
	otherPaymentReference: 18,
};
export const MANDATE_FILTER_ALL = 'All';
export const MANDATE_FILTER_STANDING_ORDERS = 'Standing orders';
export const MANDATE_FILTER_DIRECT_DEBITS = 'Direct Debits';
export const MANDATE_FILTER_OTHER_SCHEDULE = 'Other scheduled payments';
export const MANDATE_PAGE_SIZE = 100;

export const managePaymentFilterOptions = [
	{
		id: 1,
		type: MANDATE_FILTER_ALL,
	},
	{
		id: 2,
		type: MANDATE_FILTER_DIRECT_DEBITS,
	},
	{
		id: 3,
		type: MANDATE_FILTER_STANDING_ORDERS,
	},
	{
		id: 4,
		type: MANDATE_FILTER_OTHER_SCHEDULE,
	},
];

export const ACTIVE_TAB = 'ACTIVE_TAB';
export const ARCHIVED_TAB = 'ARCHIVED_TAB';

export const MANDATE_RECORD_TYPE_ACTIVE = 'active';
export const MANDATE_RECORD_TYPE_ARCHIVED = 'archived';

export const MANDATE_TYPE_STANDING_ORDER = 'Standing order';
export const MANDATE_TYPE_DIRECT_DEBIT = 'Direct Debit';
export const MANDATE_TYPE_SCHEDULE_PAYMENT = 'Payment';
export const MANDATE_TYPE_SCHEDULE_TRANSFER = 'Transfer';
export const MANDATE_TYPE_BACS_CREDIT = 'Bacs Credit';
export const MANDATE_TYPE_BACS_DEBIT = 'Bacs Debit';
export const MANDATE_TYPE_IFT = 'International';
export const MANDATE_TYPE_CHAPS = 'CHAPS';

export const managePaymentTabOptions = [
	{
		id: ACTIVE_TAB,
		title: 'Active',
	},
	{
		id: ARCHIVED_TAB,
		title: 'Archived',
	},
];

export const sortOrders = {
	desc: 'asc',
	asc: 'desc',
};
export const updateTemplateResponse = { duplicateName: 'dup_name', newVersion: 'new_ver' };
export const swiftRegex = /[0-9A-Za-z/?:().,'+\n -]/;
export const swiftRegexMultiChar = /^[0-9A-Za-z/?:().,'+\n -]*$/;
export const swiftFormat = /[^0-9A-Za-z/?:().,'+\n -]/g;

const alertTypes = {
	WARNING: 'warning',
	INFO: 'info',
};

export const notificationTypeMappings = {
	missingBen: alertTypes.WARNING,
	missingBenTemplate: alertTypes.WARNING,
	backendBenImportError: alertTypes.WARNING,
	backendBenImportWithAllError: alertTypes.WARNING,
	backendBenImportWithAllDuplicates: alertTypes.INFO,
	backendBenImportWithAllErrorsAndDuplicates: alertTypes.WARNING,
	backendBenImportPartialSuccessWithError: alertTypes.WARNING,
	backendBenCheckingPartialSuccessWithError: alertTypes.WARNING,
	backendBenImportPartialSuccessWithoutError: alertTypes.INFO,
	frontEndError: alertTypes.WARNING,
	frontEndEmptyFileError: alertTypes.WARNING,
	frontEndErrorBacsPayment: alertTypes.WARNING,
	frontEndErrorFPSPayment: alertTypes.WARNING,
	serviceErrorDuringPaymentUpload: alertTypes.WARNING,
	permissionError: alertTypes.WARNING,
};

export const authoriserType = {
	single: 'single',
	multi: 'dual',
};
export const treasuryNumber = '0800 121 4209';

export const readTimeOut = 'read timed out';

export const eeaSharedOnlyCurrencies = ['BGN', 'CZK', 'DKK', 'HUF', 'HRK', 'NOK', 'PLN', 'RON', 'GBP', 'SEK', 'EUR'];
export const IFT_OVER_LIMIT_ERROR_CODE = '1003';
export const IFT_CHAIN_BUILD_ERROR_CODE = '40141';
export const IFT_DIFFERENT_CURRENCY_ERROR_CODE = '3104';

export const environments = {
	dev: 'dev',
	int3: 'int3',
	local: 'local',
	nonprod: 'nonprod',
	production: 'production',
	sit6: 'sit6',
	tat: 'tat',
	prod: 'prod',
	unknown: 'unknown',
};

export const currenciesForCalender = ['GBP', 'EUR', 'USD'];
export const benTypes = {
	ALL: 'ALL',
	IFT: 'IFT',
	UK: 'UK',
};
export const invalidRepeatingPaymentRegex = /[^0-9]/g;

export const copReasonCodes = {
	closeMatch: {
		MBAM: 'MBAM',
		PANM: 'PANM',
		BAMM: 'BAMM',
		BANM: 'BANM',
		PAMM: 'PAMM',
	},
	noMatch: {
		ANNM: 'ANNM',
		AC01: 'AC01',
		IVCR: 'IVCR',
		ACNS: 'ACNS',
		OPTO: 'OPTO',
		CASS: 'CASS',
		SCNS: 'SCNS',
		SCNF: 'SCNF',
		ERR1: 'ERR1',
		ERR2: 'ERR2',
	},
	countAsRetryAttempt: {
		ANNM: 'ANNM',
		AC01: 'AC01',
		IVCR: 'IVCR',
		ACNS: 'ACNS',
		OPTO: 'OPTO',
		CASS: 'CASS',
		SCNS: 'SCNS',
		SCNF: 'SCNF',
	},
};

export const copAccountTypes = {
	Personal: 'Personal',
	Business: 'Business',
};

export const copCustomerType = {
	Retail: 'retail',
	Business: 'business',
};

export const COP_MAX_TRY_COUNT = 5;
export const ibRouteConstants = {
	paymentStatus: 'WEB-MANAGE-PAYMENT-STATUS',
};

export const copMatchMadeTimeOut = 3000;
